import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Container, Box, Typography, Paper } from '@mui/material';
import GISDashboard from '../../components/GeosMap/GISDashboard';
import { setSidebarOpen } from '../../store/slices/uiSlice';

const GeospatialReport = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setSidebarOpen(false));
    
    // Optional: Reopen sidebar when component unmounts
    // return () => {
    //   dispatch(setSidebarOpen(true));
    // };
  }, [dispatch]);

  return (
      <Box>
        <GISDashboard />
      </Box>
  );
};

export default GeospatialReport;
